<h2 mat-dialog-title>
  <span>
    {{ categoryTitleKey | translate }}
    <ng-container *ngIf="historyObject.category === 'fu_response'">
      {{ 'VIA' | translate }} {{ historyObject.channel }}
    </ng-container>
    {{ 'ON' | translate }}
    {{ historyObject.createdTs | dateChecker }}
  </span>
  <i class="far fa-times-circle medis-icon-large" mat-dialog-close></i>
</h2>
<mat-dialog-content>
  <div *ngIf="historyMessage">
    <p class="text-14-700-dark medis-mr-5">
      {{ 'From' | translate }}:
      <span class="medis-tag-13-azure selected">{{ historyMessage.fromHeader }}</span>
    </p>
    <p class="text-14-700-dark medis-mr-5">
      {{ 'To' | translate }}:
      <span class="medis-tag-13-azure selected">{{ historyMessage.toHeader }}</span>
    </p>
    <p class="text-14-700-dark medis-mr-5">
      {{ 'SUBJECT' | translate }}: {{ historyMessage.subject }}
    </p>
  </div>
  <app-message [message]="message"></app-message>
  <p class="text-14-700 mb-2">{{ 'MESSAGE' | translate }}:</p>
  <div [innerHTML]="historyObject.text | sanitizeHtml"></div>
  <div *ngFor="let link of historyObject.attachments">
    <app-link-visualization
      [link]="link"
      [allowRemove]="false"
      [canOpenFile]="loggedInUserIsSysAdmin || !link.isDeleted"
    ></app-link-visualization>
  </div>
</mat-dialog-content>
